import React, { useEffect, useState } from "react";
import { CircularProgress, Box } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";
import { fetchCurrentCustomerDetails } from "../services/userService";

const ProtectedRoute = ({ children }) => {
  const { accessToken, userDetails } = useAuth();
  const location = useLocation();
  const [checkingMfa, setCheckingMfa] = useState(true);
  const [mfaConfigured, setMfaConfigured] = useState(false);

  useEffect(() => {
    if (!accessToken) return;
    const checkMfa = async () => {
      const result = await fetchCurrentCustomerDetails();
      setMfaConfigured(Boolean(result.success && result.data?.mfaTyp));
      setCheckingMfa(false);
    };
    checkMfa();
  }, [accessToken]);

  if (!accessToken) {
    return <Navigate to="/login" />;
  }

  if (checkingMfa) {
    return <Box sx={{ textAlign: "center", p: 3 }}><CircularProgress /></Box>;
  }

  if (!mfaConfigured && !userDetails.mfaSetupBypassed && location.pathname !== "/zvk/mfa-settings") {
    return <Navigate to="/zvk/mfa-settings" replace />;
  }

  return children;
};

export default ProtectedRoute;
